import { Control } from 'react-hook-form';
import { PostPaymentOrderResponse } from '@dtp/membership-service-types';

export type OrderSummary = NonNullable<PostPaymentOrderResponse['summary']['orderSummaries']>[number];

export interface SummaryProps {
  products?: { productId: string; amount: string };
  orderSummaries?: OrderSummary[];
  grandTotal?: number;
  useOriginalPrice?: boolean;
}

export interface SummaryProviderProps {
  control: Control;
  useOriginalPrice?: boolean;
}

// Split product name for cleaner view in Summary.
export const getProductNameParts = (name: string) => {
  const idpPrefix = 'Internasjonalt førerkort';
  if (name.startsWith(idpPrefix)) {
    const duration = name.substring(idpPrefix.length).trim();
    return { mainTitle: idpPrefix, subTitle: duration };
  }
  return { mainTitle: name, subTitle: null };
};
